import React, { useContext, useEffect, useState } from 'react';
import { Button, Dropdown, Form, Modal } from 'react-bootstrap';
import { UserContext } from '../contexts/UserContext';
import { showConfirmationAlert, showDefaultAlert } from '../utils/alerts';
import { createTenant } from '../services/tenantsService';

const TenantModel = ({ closeModel, setAddedTenant }) => {
    const { token } = useContext(UserContext);
    const [show, setShow] = useState(false);
    const [tenantName, setTenantName] = useState('');
    const [status, setStatus] = useState('Active');
    const [validationError, setValidationError] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        setShow(true);
    }, []);

    const validateForm = () => {
        if (!tenantName.trim() || !status) {
            setValidationError(true);
            return false;
        }
        return true;
    };

    const handleClose = () => {
        setShow(false);
        closeModel(false);
    };

    const handleStatusDropdown = (eventKey) => {
        setStatus(eventKey);
        setValidationError(false);
    };

    const handleSubmit = async () => {
        if (!validateForm() || isSubmitting) {
            return;
        }

        const confirmationMessage = 'Are you sure you want to add this tenant?';

        showConfirmationAlert({
            confirmationMessage,
            onConfirm: async () => {
                setIsSubmitting(true);
                try {
                    const response = await createTenant(tenantName, status, token);
                    if (response.status === 200 || response.status === 201) {
                        showDefaultAlert('success', 'Success', 'Successfully added the tenant.');
                        setAddedTenant(response.data);
                    }
                    handleClose();
                } catch (error) {
                    setIsSubmitting(false);
                    showDefaultAlert('error', 'Error', 'An error occurred. Please try again later.');
                    handleClose();
                }
            },
        });
    };

    return (
        <>
            <Modal show={show} onHide={handleClose} className="tenant-modal" dialogClassName="tenant-modal__dialog">
                <Modal.Header closeButton>
                    <Modal.Title>Add Tenant</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ margin: 'auto' }}>
                    <Form>
                        <Form.Group className="mb-3" controlId="tenantName">
                            <Form.Label className="tenant-form-label">Tenant Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter tenant name"
                                value={tenantName}
                                onChange={(e) => {
                                    setTenantName(e.target.value);
                                    setValidationError(false);
                                }}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="tenantStatus">
                            <Form.Label className="tenant-form-label">Status</Form.Label>
                            <Dropdown data-bs-theme="light" onSelect={handleStatusDropdown}>
                                <Dropdown.Toggle className="tenant-dropdown" style={{ color: 'black' }}>
                                    {status}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item eventKey="Active">Active</Dropdown.Item>
                                    <Dropdown.Item eventKey="Inactive">Inactive</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Form.Group>
                        {validationError && (
                            <p className="text-danger">Please fill in all required fields.</p>
                        )}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose} className="tenants-btn">
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleSubmit} disabled={isSubmitting} className="tenants-btn">
                        {isSubmitting ? 'Adding...' : 'Add Tenant'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default TenantModel;
